module.exports = __webpack_public_path__ + "static/media/mockup3.48f9cb6c.png";